import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  inject,
  viewChild
} from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { ZendeskService } from '@zendesk/services/zendesk.service';
import { ZENDESK_STORE } from '@zendesk/stores/zendesk.store';

@Component({
  selector: 'app-zendesk-floating-button',
  standalone: true,
  templateUrl: './zendesk-floating-button.component.html',
  styleUrls: ['./zendesk-floating-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, MatBadge, MatFabButton, MatIcon, MatTooltip]
})
export class ZendeskFloatingButtonComponent {
  readonly #zendeskStore = inject(ZENDESK_STORE);
  readonly #zendeskService = inject(ZendeskService);

  readonly canShowSupport = this.#zendeskStore.canShowWidget;
  readonly isSupportOpen = this.#zendeskStore.isOpen;
  readonly supportUnreadCount = this.#zendeskStore.unreadCount;

  private readonly supportToggle = viewChild('supportToggle', {
    read: ElementRef<HTMLElement>
  });

  constructor() {
    effect(() => {
      this.#zendeskService.registerToggleElement(
        this.supportToggle()?.nativeElement ?? null
      );
    });
  }

  toggleSupport(event: MouseEvent): void {
    event.stopPropagation();
    this.#zendeskService.toggle();
  }
}
